// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__DnQGQ","container":"Footer_container__zMm3K"};